import React from 'react';
import '../../Home/Courses/Courses.css';
import coursesImage from '../../../assets/Gallery/coursesImage.png'; 
import { Link } from 'react-router-dom';

function AllCourses() {
    return (
        <div className='courses-outer w-100 h-100 d-flex justify-content-center align-items-center'>
            <div className="courses-inner w-100 h-100 d-flex justify-content-center align-items-center">
                <div className="courses-left d-flex justify-content-center align-items-center">
                    <div className="image-div">
                        <img src={coursesImage} alt="" loading='lazy'/>
                    </div>
                </div>
                <div className="courses-right">
                    <h2 className='secondary-header'>Courses we offer</h2>
                    <div className="learn-more-div">
                        <div className="learn-more">
                            <p className="cta-text">Hotel Management</p>
                            <button className="cta-text"><Link to='/hotel-management'>Learn More</Link></button>
                        </div>
                        <div className="learn-more">
                            <p className="cta-text">Food and Beverages Management</p>
                            <button className="cta-text"><Link to='/hotel-management'>Learn More</Link></button>
                        </div>
                        <div className="learn-more">
                            <p className="cta-text">Front Production Management</p>
                            <button className="cta-text"><Link to='/hotel-management'>Learn More</Link></button>
                        </div>
                        <div className="learn-more">
                            <p className="cta-text">Foreign Language (German& Spanish)</p>
                            <button className="cta-text"><Link to='/special-courses'>Learn More</Link></button>
                        </div>
                        <div className="learn-more">
                            <p className="cta-text">Personality Development</p>
                            <button className="cta-text"><Link to='/special-courses'>Learn More</Link></button>
                        </div>
                        <div className="learn-more">
                            <p className="cta-text">WCT from Australia & USA</p>
                            <button className="cta-text"><Link to='/special-courses'>Learn More</Link></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AllCourses
